'use client'
import { useCart } from '@/contexts/CartContext'
import { useUser } from '@/contexts/UserContext'
import { Product } from '@/types'
import { Button, RadioGroup, Select, SelectItem, useDisclosure, } from '@nextui-org/react'
import React, { useEffect, useState } from 'react'
import { HiExternalLink } from "react-icons/hi";
import { addToCart } from '@/helpers/Functions/cart'
import Link from 'next/link'
import { useSnackbar } from '@/contexts/SnackbarContext'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import PremixPack from './PremixPack'
import CustomRadio from './CustomRadio'
import { createUniquePayPalProdId } from '@/helpers/Functions/TopLevel'
type Props = {
    product: Product,
    products: Product[],
    is1kg: boolean,
    setIs1kg: React.Dispatch<React.SetStateAction<boolean>>
}

const ProductPurchase = (props: Props) => {
    const searchParams = useSearchParams()
    const router = useRouter()
    const pathname = usePathname()
    const getPacks = () => {
        const productsVar = searchParams.get('products')
        const products = productsVar?.split("-")
        if (products && products.length > 0) {
            return products.length <= 2 ? 2 : products.length <= 4 ? 4 : 6
        }
        else {
            return 2
        }

    }

    const [pack, setPack] = React.useState(
        getPacks()
    );
    const { cart, setCart } = useCart();
    const { signedIn } = useUser();
    const { showSnackbar } = useSnackbar()
    const getSelected = () => {
        const products = searchParams.get('products')?.split("-")
        if (products && products.length > 0 && products.includes(`${props.product.id}`)) {
            return products
        }
        else {
            return [`${props.product.id}`]
        }
    }
    const [selected, setSelected] = React.useState(
        getSelected()
    );
    const [added, setAdded] = React.useState(false);
    const [desc, setDesc] = React.useState("");
    const [isSubscription, setIsSubscription] = useState(false);
    const handlePack = (pack: number) => {
        setPack(pack);
    }
    useEffect(() => {
        const products = selected.join("-")
        router.push(
            `/products/${props.product.uniqueid}?products=${products}`, { scroll: false }
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected])

    useEffect(() => {
        setAdded(false);
        setSelected([selected[0]]);
        router.push(
            `/products/${props.product.uniqueid}?products=${selected[0]}`, { scroll: false }
        )

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.is1kg]);

    const calcPrice = (pack: number = 1, selected: string[]): number => {
        let sum = 0
        selected.forEach((id) => {
            props.products.forEach((product) => {
                if (product.id == id) {
                    let price;
                    !props.is1kg ? (price = (typeof product.price === 'string') ? (parseFloat(product.price)) : product.price) : (price = (typeof product.price1kg === 'string') ? (parseFloat(product.price1kg)) : product.price1kg);
                    sum += price;
                }
            })
        })
        return sum
    }
    return (
        <>
            {
                props.product.category == "Premix" ?
                    <PremixPack myProducts={props.products} selected={selected} setSelected={setSelected} pack={pack} handlePack={handlePack} product={props.product} is1kg={props.is1kg} />
                    : ""
            }

            {
                props.product.category == "Premix" &&
                <>
                    <RadioGroup label="Choose a method" defaultValue={
                        isSubscription ? 'sub' : 'cart'
                    } onChange={
                        (e) => {
                            if (e.target.value == 'sub') {
                                setIsSubscription(true)
                            }
                            else {
                                setIsSubscription(false)
                            }
                        }

                    }>
                        <CustomRadio description="Add to cart for now!" value="cart">
                            One Time Purchase
                        </CustomRadio>
                        <CustomRadio description="Get at 80% of Original Price" value="sub">
                            Subscribe Now & Save More
                        </CustomRadio>
                    </RadioGroup>
                </>
            }

            {
                added ?
                    <>
                        <Link href='/cart' className='text-center p-4 rounded-md text-white hover:outline-black outline-none outline-offset-0 hover:bg-[#afd72b] bg-[#afd72b] w-full'>
                            Continue
                        </Link>
                        {/* <Button onClick={() => {
                            router.push("/products")
                        }} className='text-center p-4 rounded-md text-white hover:outline-black outline-none outline-offset-0 hover:bg-[#94b036] bg-[#819b2d] w-full'>
                            Continue Shopping
                        </Button> */}
                    </>
                    :
                    <>
                        {
                            props.product.category == 'Premix' ?
                                isSubscription ?
                                    <>
                                        {

                                            <Button isDisabled={selected.length != pack}
                                                onPress={
                                                    signedIn ? async () => {
                                                        if (props.is1kg) {
                                                            showSnackbar(3000, 3, "Subscription are only for 1 lb combos!");
                                                        }
                                                        router.push(`/shipping/subscribe?productid=${createUniquePayPalProdId(selected.map((id) => parseInt(id)))}`)
                                                    } : () => {
                                                        router.push(`/auth?redirect=${pathname}${searchParams.size > 0 ? `?${searchParams}` : ''}`)
                                                    }
                                                }
                                                size='lg' radius='sm' className={`text-white hover:outline hover:outline-2 hover:outline-black outline-offset-0 hover:bg-[#afd72b] bg-[#afd72b] ${!signedIn ? 'bg-amber-500 hover:bg-amber-400' : ''}`}
                                            >
                                                {(selected.length != pack) ? `Select ${pack} items` : signedIn ? "Continue" : "Sign In to Subscribe"}
                                            </Button>
                                        }
                                    </> :
                                    <>
                                        <Button isDisabled={selected.length != pack} size='lg' radius='sm' className={`text-white hover:outline hover:outline-2 hover:outline-black outline-offset-0 hover:bg-[#afd72b] bg-[#afd72b]`}
                                            onClick={async () => {
                                                setAdded(true);
                                                await addToCart(
                                                    selected.map((id) => props.products.find((product) => product.id == id) as Product),
                                                    cart, setCart, signedIn, showSnackbar, props.is1kg
                                                );
                                                console.log(cart)
                                            }}
                                        >
                                            {(selected.length != pack) ? `Select ${pack} items` : `Add to Cart $ ${calcPrice(pack, selected).toFixed(2)
                                                }`}
                                        </Button>
                                    </>
                                :

                                props.product.category == 'Drink' || props.product.category == 'Cold' ?
                                    <>
                                        <Link href="https://order.online/business/~12620887/" target='_blank' className='text-center p-4 rounded-md text-white hover:outline-black outline-none outline-offset-0 hover:bg-[#94b036] bg-[#afd72b] w-full flex gap-4 items-center justify-center'>
                                            <span>
                                                Order Now
                                            </span>
                                            <HiExternalLink size={24} />
                                        </Link>
                                    </>

                                    : props.product.textrequired === 1 ?
                                        <>
                                            <div>
                                                <textarea value={desc} className='w-full p-4 rounded-md text-gray-900 border-1 border-black border-offset-0 focus:outline-0 focus:outline-black focus:outline-offset-0 focus:border-1'
                                                    placeholder={props.product.description} onChange={(e) => setDesc(e.target.value)}
                                                ></textarea>
                                            </div>
                                            <Button size='lg' radius='sm' className={`text-white hover:outline hover:outline-2 hover:outline-black outline-offset-0 hover:bg-[#afd72b] bg-[#afd72b]`} isDisabled={
                                                desc.trim() == ""
                                            }
                                                onClick={async () => {
                                                    setAdded(true);
                                                    await addToCart([props.product], cart, setCart, signedIn, showSnackbar, props.is1kg, desc);

                                                    console.log(cart)
                                                }}
                                            >
                                                Add to Cart
                                            </Button>
                                        </>
                                        :

                                        <>
                                            <Button size='lg' radius='sm' className={`text-white hover:outline hover:outline-2 hover:outline-black outline-offset-0 hover:bg-[#afd72b] bg-[#afd72b]`}
                                                onClick={async () => {
                                                    setAdded(true);
                                                    await addToCart([props.product], cart, setCart, signedIn, showSnackbar, props.is1kg);

                                                    console.log(cart)
                                                }}
                                            >
                                                Add to Cart
                                            </Button>
                                        </>
                        }
                    </>
            }
        </>
    )
}

export default ProductPurchase